import { render, staticRenderFns } from "./StarItem.vue?vue&type=template&id=afca08cc&scoped=true&"
import script from "./StarItem.vue?vue&type=script&lang=js&"
export * from "./StarItem.vue?vue&type=script&lang=js&"
import style0 from "./StarItem.vue?vue&type=style&index=0&id=afca08cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afca08cc",
  null
  
)

export default component.exports